<template>
  <div class="app-container">
    <Header class="header" />
    <main class="content">
      <router-view />
    </main>
    <Footer class="footer" />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Header,
    Footer,
  },
};
</script>

<style scoped></style>
